export default __webpack_public_path__ + "static/media/nucleo-icons.cba26748.woff2";